import { useState } from 'react';
import { Auth } from 'aws-amplify';
import Honeybadger from '@honeybadger-io/js';

import { graphql } from 'kb-shared';
const { client, mutate } = graphql;
const { UPDATE_FEDERATED_ID } = mutate;

const useConnectPatientToS3 = () => {
  const [responseState, setResponseState] = useState({
    finished: false,
    succeeded: false,
    error: null
  });
  const connectPatientToS3 = async (
    identityProvider: string,
    idtoken: string,
    patientName: string
  ): Promise<any> => {
    const federateTokenData = {
      token: idtoken,
      // 30 days from now
      // not sure what is exactly "expiring" here. it has nothing to do with itoken.exp
      // eslint-disable-next-line @typescript-eslint/camelcase
      expires_at: Date.now() + 60 * 60 * 24 * 1000 * 30
    };
    // it doesn't matter what you fill in here, the data is not stored in AWS identity pool, nor anywhere else
    const federatedPatientData = {
      name: patientName
    };

    try {
      // this is upsert. on the very first login, the record (idtoken.sub) is inserted into AWS identity pool
      // and the identity ID is returned
      // on subsequent logins, the existing ID is returned for given (idtoken.sub)
      const response = await Auth.federatedSignIn(
        identityProvider,
        federateTokenData,
        federatedPatientData
      );
      const patientIdentityPoolId = response.identityId;

      // make sure idtoken is already set at this point
      // we actually need to call this only at the very first login, but we'd have to make
      // one additional graphql get to figure it out.. so this is simple and good enough
      await client.mutate({
        mutation: UPDATE_FEDERATED_ID,
        variables: {
          federatedId: patientIdentityPoolId
        }
      });

      setResponseState({
        finished: true,
        succeeded: true,
        error: null
      });
    } catch (error) {
      Honeybadger.notify(error);
      setResponseState({
        finished: true,
        succeeded: false,
        error
      });
    }
  };

  const useHookTuple: [
    ResponseStateType,
    (identityProvider: string, idtoken: string, patientName: string) => Promise<any>
  ] = [responseState, connectPatientToS3];
  return useHookTuple;
};

type ResponseStateType = {
  finished: boolean;
  succeeded: boolean;
  error: any;
};

export default useConnectPatientToS3;
